import { api } from "../../Lib/constants";
import { DASHBOARD, DASHBOARD_FAILED, DASHBOARD_SUCCESS } from "./actionTypes";
import { getAuthHeader } from "../../Lib/utils";

export const getDashboardData = (id) => async (dispatch) => {
  dispatch({
    type: DASHBOARD,
  });
  try {
    let response = await api(`dashboard/${id}`, "get", {}, getAuthHeader());
    dispatch({
      type: DASHBOARD_SUCCESS,
      payload: response?.data,
    });
    return response?.data;
  } catch (error) {
    console.log(error);
    return dispatch({
      type: DASHBOARD_FAILED,
      payload: error?.message,
    })
  }
};
